"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Components_1 = require("../../Components");
var Pages_1 = require("./Pages");
var Types_1 = require("../../Types");
var react_router_dom_1 = require("react-router-dom");
var History_1 = require("../../../../Utils/History");
var Components_2 = require("../../../../Components");
var Reports = /** @class */ (function (_super) {
    __extends(Reports, _super);
    function Reports(props) {
        var _this = _super.call(this, props) || this;
        _this.actionButtonOnClick = function (action) {
            _this.setState({ selectedAction: action }, function () { return History_1.default.push("/Dashboard/Reports/" + action.value); });
        };
        _this.actions = [
            Types_1.ReportsAction.History(_this.props.applicationData.resources),
            Types_1.ReportsAction.RequestLookup(_this.props.applicationData.resources)
        ];
        _this.state = {
            selectedAction: _this.actions.filter(function (action) { return window.location.pathname.endsWith(action.value); }).pop() || _this.actions[0]
        };
        return _this;
    }
    Reports.prototype.render = function () {
        var _this = this;
        return (React.createElement(Components_1.DashboardPage, { content: React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/Reports/History', render: function () { return React.createElement(Pages_1.VeriLiteHistory, { applicationData: _this.props.applicationData }); } }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/Reports/RequestLookup', render: function () { return React.createElement(Pages_1.RequestLookup, { applicationData: _this.props.applicationData }); } }),
                React.createElement(react_router_dom_1.Route, { render: function () { return React.createElement(Components_2.SafeRedirect, { to: "/Dashboard/Reports/History", resources: _this.props.applicationData.resources }); } })), actions: this.actions.map(function (action) {
                return React.createElement(Components_1.ActionButton, { key: action.value, action: action, onClick: function () { _this.actionButtonOnClick(action); }, active: _this.state.selectedAction == action });
            }), placeholder: this.props.applicationData.resources.ActionsWillAppear_Single, title: this.state.selectedAction.value === Types_1.ReportsAction.History(this.props.applicationData.resources).value ? this.props.applicationData.resources.ActivityReport : "", resources: this.props.applicationData.resources }));
    };
    return Reports;
}(React.Component));
exports.Reports = Reports;
//# sourceMappingURL=Reports.js.map